module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"extend_subscription":"Продлить доступ"},"en":{"extend_subscription":"Subscribe to HoneyMoney"}}')
  delete Component.options._Ctor
}
